import { useNavigate } from 'react-router-dom';

import usePlans from '../../../api/usePlans';
import { BillingPeriodUnit } from '../../../common/contracts';
import DataTable from '../../../components/DataTableComponent/DataTable';
import FilterDropdownCard from '../../../components/Filter/FilterDropdownCard';
import FilterSearchCard from '../../../components/Filter/FilterSearchCard';
import { useState } from 'react';
import { DateRange } from 'react-day-picker';
import DatePicker from 'components/DatePicker/DatePicker';
import { DatePickerMode } from 'components/DatePicker/DatePicker.types';
import { DEFAULT_DATE_RANGE } from 'views/Analytics/utils';
import { usePlansColumns } from '../hooks/use-plans-columns';

interface PlansTabProps {
  isLoading: boolean;
  isEmpty: boolean;
}

export const PlansTable: React.FC = () => {
  const navigate = useNavigate();
  const [billingPeriod, setBillingPeriod] = useState<string>('');
  const [dateRange, setDateRange] = useState<DateRange>(DEFAULT_DATE_RANGE);
  const [planName, setPlanName] = useState<string>('');

  const { getPlans, archivePlan } = usePlans();
  const { columns } = usePlansColumns(archivePlan, getPlans);

  const handleDateRangeChange = (value: DateRange) => {
    setDateRange(value);
    // setPreviousDateRange(undefined);
  };

  const isLoading = getPlans.isLoading;
  const isEmpty = getPlans.data?.length === 0;

  return (
    <div>
      {!isEmpty && (
        <div className="flex pb-3 pt-1 gap-3">
          <FilterDropdownCard
            header="Billing period"
            isLabelSearchBy
            filterValue={billingPeriod}
            setFilterValue={(value) => setBillingPeriod(value)}
            options={[
              { label: 'Daily', value: BillingPeriodUnit.DAILY },
              { label: 'Weekly', value: BillingPeriodUnit.WEEKLY },
              { label: 'Monthly', value: BillingPeriodUnit.MONTHLY },
              { label: 'Yearly', value: BillingPeriodUnit.YEARLY }
            ]}
          />

          <FilterSearchCard
            header="Plan name"
            filterValue={planName}
            setFilterValue={(value) => setPlanName(value)}
          />

          <div>
            <DatePicker
              shouldDisplayTime={false}
              mode={DatePickerMode.RANGE}
              value={dateRange}
              onApply={(value) => handleDateRangeChange(value as DateRange)}
              shouldExcludeFuture
            />
          </div>
        </div>
      )}

      <DataTable
        data={getPlans.data || []}
        columns={columns}
        rowIdIdentifier="offerId"
        isLoading={isLoading}
        emptyStateConfig={{
          title: ' plan',
          isEmpty,
          description: (
            <>
              A subscription plan enables recurring access for your players and
              can be
              <br />
              configured to suit your monetization strategy.
            </>
          ),
          onClick: () => navigate('./form')
        }}
        bordered
      />
    </div>
  );
};
